var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamiliplusMobileGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4928 17.4619H10.5127C8.94701 17.4619 7.67773 18.7312 7.67773 20.2969V37.3735C7.67773 38.9392 8.94701 40.2085 10.5127 40.2085H37.4928C39.0585 40.2085 40.3278 38.9392 40.3278 37.3735V20.2969C40.3278 18.7312 39.0585 17.4619 37.4928 17.4619Z",
    fill: "url(#paint0_linear_6598_9670)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.892 13.2021H8.11623C7.16833 13.2021 6.3999 13.9706 6.3999 14.9185V18.7038C6.3999 19.6517 7.16833 20.4201 8.11623 20.4201H39.892C40.8399 20.4201 41.6084 19.6517 41.6084 18.7038V14.9185C41.6084 13.9706 40.8399 13.2021 39.892 13.2021Z",
    fill: "#FFC3F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1787 40.1727L24.1787 12.4302",
    stroke: "#002C50",
    strokeWidth: 1.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6958 12.3475C23.9764 11.0127 20.5108 6.5392 18.914 8.48146C17.0044 10.8041 22.6602 13.0377 23.6958 12.3475Z",
    stroke: "#002C50",
    strokeWidth: 1.62
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0937 12.3475C23.8131 11.0127 27.2787 6.5392 28.8756 8.48146C30.7852 10.8041 25.1294 13.0377 24.0937 12.3475Z",
    stroke: "#002C50",
    strokeWidth: 1.62
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6598_9670",
    x1: 27.8647,
    y1: 38.3752,
    x2: 21.6997,
    y2: 19.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliplusMobileGift);
export default __webpack_public_path__ + "static/media/FamiliplusMobileGift.8d60cac93fe5079dc35ee4384ab99e0a.svg";
export { ForwardRef as ReactComponent };